import { render, staticRenderFns } from "./ButtonSort.vue?vue&type=template&id=472c388c"
import script from "./ButtonSort.vue?vue&type=script&lang=js"
export * from "./ButtonSort.vue?vue&type=script&lang=js"
import style0 from "./ButtonSort.vue?vue&type=style&index=0&id=472c388c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports